import {Component, EventEmitter, Input, Output} from "@angular/core";
import {OrderModel} from "../../order/order.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {OrderingContextEvents} from "../../ordering-context/ordering-context-events";

@Component({
    selector: "woa-tip-selection-panel",
    templateUrl: "./tip-selection-panel.component.html"
})
export class TipSelectionPanelComponent {
    @Input() tipAmount: number;
    @Output() tipAmountChange: EventEmitter<number> = new EventEmitter<number>();

    @Input() tipSelected: boolean;
    @Output() tipSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() showTipInstructions: boolean = false;

    OrderingContextEvents = OrderingContextEvents;

    constructor(public orderingContextModel: OrderingContextModel,
                private orderModel: OrderModel) {
    }

    get tipPercentages(): number[] {
        const percentages: number[] = [0];
        if (this.orderingContextModel.currentStore.tipPercentage1) {
            percentages.push(this.orderingContextModel.currentStore.tipPercentage1);
        }
        if (this.orderingContextModel.currentStore.tipPercentage2) {
            percentages.push(this.orderingContextModel.currentStore.tipPercentage2);
        }
        if (this.orderingContextModel.currentStore.tipPercentage3) {
            percentages.push(this.orderingContextModel.currentStore.tipPercentage3);
        }
        if (this.orderingContextModel.currentStore.tipPercentage4) {
            percentages.push(this.orderingContextModel.currentStore.tipPercentage4);
        }
        return percentages;
    }

    calculateTipAmount(percentage: number): number {
        return Math.round(this.orderModel.orderTotal * percentage) / 100;
    }

    selectTip(percentage: number): void {
        this.tipAmount = this.calculateTipAmount(percentage);
        this.tipAmountChange.emit(this.tipAmount);
        this.tipSelected = true;
        this.tipSelectedChange.emit(true);
    }

    isSelectedTip(percentage: number): boolean {
        return (percentage || this.tipSelected) && this.tipAmount === this.calculateTipAmount(percentage);
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/tip-selection-panel/tip-selection-panel.component.ts